import {DarkStoreType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import React from "react";

type SizeIndicatorsPropsType = {
    data: DarkStoreType[];
}

export const SizeIndicators = ({data}: SizeIndicatorsPropsType) => {
    // Массив для хранения суммы товаров и количества лавок по каждому размеру
    const counts = [[0, 0], [0, 0], [0, 0]]
    // Перебираем все объекты данных и распределяем по размерам лавок
    data.forEach((el) => {
        if (el.status_size === 'Обычная') {
            counts[0][0] += el.kol_vo_tovarov // Суммируем количество товаров для "Обычная"
            counts[0][1] += 1 // Считаем количество лавок "Обычная"
        }
        else if (el.status_size === 'XL') {
            counts[1][0] += el.kol_vo_tovarov // Суммируем количество товаров для "XL"
            counts[1][1] += 1 // Считаем количество лавок "XL"
        }
        else if (el.status_size === 'Большая') {
            counts[2][0] += el.kol_vo_tovarov // Суммируем количество товаров для "Большая"
            counts[2][1] += 1 // Считаем количество лавок "Большая"
        }
    })

    // Формируем массив средних значений товаров по размеру лавки
    const series = counts.map((el) => {
        if (el[1] + el[0] === 0) {
            return 0 // Если нет данных, возвращаем 0
        }
        else {
            return Math.round(el[0] / el[1]) // Вычисляем среднее количество товаров
        }
    })
    // Категории размеров лавок для оси X
    const categories = ['Обычная', 'XL', 'Большая']

    // Опции для графика ApexCharts
    const options = {
        chart: {
            type: 'bar' as const, // Тип графика: столбчатый
            height: 350,
            toolbar: {
                show: false // Отключаем тулбар
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4, // Скругление углов столбцов
                borderRadiusApplication: 'end' as const, // Скругление только на конце
                horizontal: false, // Вертикальные столбцы
                distributed: true, // Разные цвета для столбцов
            }
        },
        title: {
            text: 'Среднее количество товаров / размер лавки', // Заголовок графика
            align: 'center' as const,
            margin: 20,
            style: {
                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
            '#f48024', '#69d2e7'
        ], // Цвета для столбцов
        xaxis: {
            categories: categories, // Категории оси X
            labels: {
                style: {
                    colors: 'white', // Цвет подписей
                    fontWeight: 14,
                    fontSize: '12',
                }
            }
        },
        grid: {
            show: false // Отключаем сетку
        },
        yaxis: {
            labels: {
                show: false // Отключаем подписи оси Y
            }
        },
        tooltip: {
            enabled: true, // Включаем тултипы
            theme: 'dark', // Тёмная тема тултипов
            x: {
                show: true,
            },
            y: {
                title: {
                    formatter: function () {
                        return 'Количество продуктов' // Заголовок тултипа
                    }
                }
            },
            marker: {
                show: true,
            },
        },
        legend: {
            show: false // Отключаем легенду
        }
    }

    // Рендерим график средних значений товаров по размеру лавки
    return (
        <div>
            <ReactApexChart
                options={options}
                series={[{data: series}]}
                type={'bar'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </div>
    );
};
